<template>
  <v-card
    v-if="calculator"
    flat
    class="white vetalfa-view"
    :max-width="_getMaxWidth()"
  >
    <div class="vetalfa-global-header" ref="screenHeader">
      <vetalfa-small-header
        showBreadCrumbAndTitle
        :breadcrumb="!!calculator ? calculator.name : null"
        :title="category ? category.portugueseName : null"
        :confirmationObject="{
          text: calculatorLabels.CONFIRMATION_QUIT_CALCULATOR,
          confirmText: calculatorLabels.QUIT_CALCULATOR,
          closeText: labels.CANCEL,
        }"
        hasHeaderOptions
      ></vetalfa-small-header>
      <v-row no-gutters justify="center">
        <vetalfa-drugs-header
          :name="calculator.name"
          :description="calculator.classes[0]"
          :displayCalculator="false"
          hasCircularProgress
          class="vetalfa-max-width my-4 px-2"
        ></vetalfa-drugs-header>
      </v-row>
    </div>

    <div ref="screenContent" style="height: 100%">
      <v-stepper v-model="stepModel">
        <v-stepper-items>
          <v-stepper-content step="1" class="ma-0 pa-0">
            <vetalfa-section-title
              prop="Digite o peso do Paciente (kg)"
              :collapse="false"
            >
              <v-text-field
                v-bind:id="`numeric-weight`"
                type="text"
                hide-details
                inputmode="decimal"
                suffix="(kg)"
                class="mx-2 my-0 mb-5"
                light
                v-model="weight"
                dense
                color="primary"
                outlined
                placeholder="Insira o peso do paciente"
              ></v-text-field>
            </vetalfa-section-title>
            <vetalfa-section-title
              prop="Insira o volume total de Soro/Solução presente na Bolsa ou Seringa (mL)"
              :collapse="false"
            >
              <v-text-field
                v-bind:id="'numeric-volume'"
                type="text"
                hide-details
                inputmode="decimal"
                suffix="(mL)"
                class="mx-2 my-0 mb-5"
                light
                v-model="volume"
                dense
                color="primary"
                outlined
                placeholder="Insira o Volume"
              ></v-text-field>
            </vetalfa-section-title>
            <vetalfa-section-title
              prop="Escolha a unidade de medida da Taxa de Fluidoterapia"
              :collapse="false"
            >
              <v-select
                :items="fluidRateUnits"
                placeholder="Selecione"
                hide-details
                filled
                class="mx-2 mb-5"
                dense
                outlined
                v-model="fluidRateUnit"
              ></v-select>
            </vetalfa-section-title>
            <vetalfa-section-title
              prop="Insira o Valor da Taxa de Fluidoterapia"
              :collapse="false"
            >
              <v-text-field
                v-bind:id="`numeric-fluidrate`"
                type="text"
                hide-details
                inputmode="decimal"
                :suffix="fluidRateUnit"
                class="mx-2 my-0 mb-5"
                light
                v-model="fluidRate"
                dense
                color="primary"
                outlined
                placeholder="Insira a taxa"
              ></v-text-field>
            </vetalfa-section-title>
            <div style="height: 70px; background-color: white"></div>
          </v-stepper-content>

          <v-stepper-content step="2" class="ma-0 pa-0">
            <v-expand-transition>
              <vetalfa-section-title
                prop="Medicamentos selecionados"
                :collapse="false"
                v-show="!drugsDialogModel"
              >
                <v-row class="ma-0 pa-0" justify="center">
                  <v-col
                    class="ma-0 pa-0"
                    v-for="drug in drugs"
                    :key="drug.id"
                    cols="12"
                  >
                    <v-card
                      @click="editDrug(drug)"
                      height="150"
                      class="ma-0 pa-0 mx-2 mt-2 vetalfa-pointer"
                    >
                      <v-row
                        @click.stop="deleteDrug(drug.id)"
                        justify="end"
                        class="ma-0 pa-0"
                      >
                        <v-icon class="mr-2 mt-2">{{ mdiClose }}</v-icon>
                      </v-row>
                      <v-row class="ma-0 pa-0" justify="center">
                        <p class="vetalfa-card-title pa-0 ma-0 text-center">
                          {{ drug.name }}
                        </p>
                      </v-row>
                      <v-row class="ma-0 pa-0" justify="center">
                        <p class="pa-0 mt-1 ma-0 text-center vetalfa-card-text">
                          <span class="font-weight-bold">Concentração: </span
                          >{{
                            `${_formatNumber(
                              _strToNumber(drug.concentration)
                            )} ${drug.concentrationUnit}`
                          }}
                        </p>
                      </v-row>
                      <v-row class="ma-0 pa-0" justify="center">
                        <p class="pa-0 mt-1 ma-0 text-center vetalfa-card-text">
                          <span class="font-weight-bold"
                            >Taxa de Administração: </span
                          >{{
                            `${_formatNumber(
                              _strToNumber(drug.administrationRate)
                            )} ${drug.administrationRateUnit}`
                          }}
                        </p>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row
                  justify="center"
                  class="ma-0 pa-0 pt-2"
                  v-show="!drugs.length"
                >
                  <v-img
                    position="center"
                    height="100px"
                    class="ma-0 pa-0"
                    :src="noDrugsImage"
                    :lazy-src="noDrugsImage"
                    max-width="300"
                    contain
                  ></v-img>
                </v-row>
                <v-row
                  justify="center"
                  class="ma-0 pa-0 mt-2"
                  v-show="!drugs.length"
                >
                  <p class="ma-0 pa-0 text-center vetalfa-card-title-disabled">
                    Sem medicamentos
                  </p>
                </v-row>
                <v-row
                  justify="center"
                  class="ma-0 pa-0"
                  v-show="!drugs.length"
                >
                  <v-col cols="10" class="ma-0 pa-0">
                    <p class="ma-0 pa-0 text-center vetalfa-card-text-disabled">
                      Quando você adicionar, seus medicamentos vão aparecer
                      aqui.
                    </p>
                  </v-col>
                </v-row>
                <v-row class="ma-0 pa-0 mt-3" justify="center">
                  <v-btn
                    @click="openDrugDialog()"
                    v-if="!drugs.length"
                    class="primary text-none"
                  >
                    <p class="ma-0 pa-0 pt-1">Adicionar</p>
                  </v-btn>
                  <v-btn
                    @click="openDrugDialog()"
                    v-else
                    text
                    class="primary--text text-none text-decoration-underline"
                  >
                    <p class="ma-0 pa-0 pt-1">Adicionar outro medicamento</p>
                  </v-btn>
                </v-row>
                <div style="height: 100px; background-color: white"></div>
              </vetalfa-section-title>
            </v-expand-transition>
            <v-expand-transition>
              <div v-show="drugsDialogModel">
                <vetalfa-section-title
                  prop="Insira o nome do medicamento"
                  :collapse="false"
                >
                  <v-combobox
                    v-bind:id="`text-newdrugname`"
                    v-model="name"
                    :value="name"
                    :items="drugsConcentrations"
                    @change="selectDrug()"
                    item-text="name"
                    label="Nome do medicamento"
                    :menu-props="{ maxHeight: 154 }"
                    class="pa-2"
                    outlined
                    hide-details
                    dense
                  >
                  </v-combobox>
                </vetalfa-section-title>
                <vetalfa-section-title
                  prop="Escolha a unidade de medida [concentração] do medicamento"
                  :collapse="false"
                >
                  <v-select
                    :items="concentrationUnits"
                    placeholder="Selecione"
                    hide-details
                    filled
                    class="mx-2 mb-5"
                    dense
                    outlined
                    v-model="concentrationUnit"
                  ></v-select>
                </vetalfa-section-title>
                <vetalfa-section-title
                  prop="Insira o valor da [concentração]"
                  :collapse="false"
                >
                  <v-text-field
                    v-bind:id="`numeric-newdrugconcentration`"
                    type="text"
                    hide-details
                    inputmode="decimal"
                    :suffix="concentrationUnit"
                    class="mx-2 my-0 mb-5"
                    light
                    v-model="concentration"
                    dense
                    color="primary"
                    outlined
                    placeholder="[Concentração]"
                  ></v-text-field>
                </vetalfa-section-title>
                <vetalfa-section-title
                  prop="Escolha a unidade de medida da Taxa de Administração"
                  :collapse="false"
                >
                  <v-select
                    :items="administrationRateUnits"
                    placeholder="Selecione"
                    hide-details
                    filled
                    class="mx-2 mb-5"
                    dense
                    outlined
                    v-model="administrationRateUnit"
                  ></v-select>
                </vetalfa-section-title>
                <vetalfa-section-title
                  prop="Insira o valor da Taxa de Administração"
                  :collapse="false"
                >
                  <v-text-field
                    v-bind:id="`numeric-newdrugadministrationrate`"
                    type="text"
                    hide-details
                    inputmode="decimal"
                    :suffix="administrationRateUnit"
                    class="mx-2 my-0 mb-5"
                    light
                    v-model="administrationRate"
                    dense
                    color="primary"
                    outlined
                    placeholder="Taxa de administração"
                  ></v-text-field>
                </vetalfa-section-title>
                <v-row class="ma-0 pa-0 pt-5 my-5" justify="end">
                  <v-btn
                    outlined
                    class="text-none primary--text mr-2 ml-2"
                    @click.stop="closeDialog()"
                  >
                    Cancelar
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    v-bind:class="
                      !name ||
                      !concentrationUnit ||
                      !concentration ||
                      !administrationRateUnit ||
                      !administrationRate
                        ? 'vetalfa-disabled-btn'
                        : 'vetalfa-primary-btn'
                    "
                    :elevation="
                      !name ||
                      !concentrationUnit ||
                      !concentration ||
                      !administrationRateUnit ||
                      !administrationRate
                        ? 0
                        : 5
                    "
                    class="text-none mr-2"
                    @click="saveNewDrug()"
                  >
                    Salvar medicamento
                  </v-btn>
                </v-row>
              </div>
            </v-expand-transition>
          </v-stepper-content>

          <v-stepper-content step="3" class="ma-0 pa-0">
            <div style="height: 100%" v-if="noResults">
              <vetalfa-section-title prop="Composição da Solução">
                <v-row class="ma-0 pa-0 my-2" justify="center">
                  <pie-chart
                    v-if="chartData"
                    style="max-width: 300px !important"
                    :chartData="chartData"
                  ></pie-chart>
                </v-row>
                <vetalfa-section-item-title
                  class="mt-5"
                  prop="Volume dos líquidos"
                >
                  <vetalfa-section-item
                    v-for="label in results.labels"
                    :prop="label"
                    :key="label"
                  ></vetalfa-section-item>
                </vetalfa-section-item-title>

                <vetalfa-section-item-title
                  prop="Concentrações dos medicamentos na solução:"
                >
                  <vetalfa-section-item
                    v-for="(drug, index) in results.drugs"
                    :key="drug.name"
                    :prop="drug.name"
                    :index="index"
                  >
                    <vetalfa-section-sub-item
                      v-for="(concentration, index) in drug.concentrations"
                      :key="concentration"
                      :prop="concentration"
                      :index="index"
                    ></vetalfa-section-sub-item>
                  </vetalfa-section-item>
                </vetalfa-section-item-title>
              </vetalfa-section-title>
              <vetalfa-section-title :prop="'Velocidade de Administração'">
                <vetalfa-section-item-title
                  prop="Velocidade na bomba de infusão"
                >
                  <vetalfa-section-item
                    :prop="results.bombSpeed"
                  ></vetalfa-section-item>
                </vetalfa-section-item-title>
                <vetalfa-section-item-title
                  prop="Velocidade no equipo Macrogotas"
                >
                  <vetalfa-section-item
                    v-for="(obj, index) in results.macroDrops"
                    :key="index + obj"
                    :prop="obj"
                    :index="index"
                  ></vetalfa-section-item>
                </vetalfa-section-item-title>
                <vetalfa-section-item-title
                  prop="Velocidade no equipo Microgotas"
                >
                  <vetalfa-section-item
                    v-for="(obj, index) in results.microDrops"
                    :key="index + obj"
                    :prop="obj"
                    :index="index"
                  ></vetalfa-section-item>
                </vetalfa-section-item-title>
              </vetalfa-section-title>
              <vetalfa-section-title :prop="'Duração do Volume de Soro'">
                <vetalfa-section-item-title
                  prop="Caso a taxa de fluidoterapia se mantenha a informada, o volume total de soro informado será infundido em:"
                >
                  <vetalfa-section-item
                    :prop="results.serumDuration"
                  ></vetalfa-section-item>
                </vetalfa-section-item-title>
              </vetalfa-section-title>
              <vetalfa-general-tab
                :sections="calculator.sections"
                :references="calculator.references"
              ></vetalfa-general-tab>
              <div style="height: 70px; background-color: white"></div>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
    <v-row
      v-if="!drugsDialogModel"
      class="ma-0 pa-0 white vetalfa-max-width"
      align="center"
      v-bind:style="`
        width: 100%;
        position: fixed;
        bottom: ${_isIos() ? 30 : 0}px;
        z-index: 10;
        height: 50px;
      `"
      justify="space-around"
    >
      <v-col :cols="$vuetify.breakpoint.xsOnly ? 6 : 4" class="ma-0 pa-0">
        <v-row class="ma-0 pa-0 pl-2 pr-1 pb-2" align="center" justify="start">
          <v-btn
            v-show="stepModel == 2 || stepModel == 3"
            block
            outlined
            class="text-none primary--text"
            @click="stepModel -= 1"
          >
            Voltar
          </v-btn>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
      <v-col :cols="$vuetify.breakpoint.xsOnly ? 6 : 4" class="ma-0 pa-0">
        <v-row class="ma-0 pa-0 pr-2 pl-1 pb-2" align="center" justify="end">
          <v-btn
            block
            v-show="stepModel < 3"
            :elevation="disabledStep ? 0 : 5"
            v-bind:class="
              disabledStep ? 'vetalfa-disabled-btn' : 'vetalfa-primary-btn'
            "
            class="text-none"
            @click="stepModel += disabledStep ? 0 : 1"
            light
          >
            {{ stepModel == 2 ? "Ver resultados" : "Continuar" }}
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<style>
.v-stepper {
  box-shadow: unset !important;
  -webkit-box-shadow: unset !important;
}
.v-stepper__header {
  box-shadow: unset !important;
  -webkit-box-shadow: unset !important;
}
</style>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import calculatorLabels from "@/constants/labels/calculators.labels.js";
import { mdiCheck, mdiPlus, mdiClose, mdiAlertCircleOutline } from "@mdi/js";
import labels from "@/constants/labels.js";
import imagesConstants from "@/constants/images.js";
import PieChart from "@/components/PieChart.js";
const stepperData = [
  { title: "Primeiros passos" },
  { title: "Seleção de medicamentos" },
  { title: "Resultados" },
];
export default {
  name: "ContinuousInfusionCalculator",
  components: {
    "pie-chart": PieChart,
  },
  watch: {
    stepModel(val) {
      this.logEvent({
        name: "continuousInfusionStepChange",
        object: { step: val },
      });
      this.$vuetify.goTo(0, {
        duration: 0,
        offset: 0,
        easing: "easeInOutCubic",
      });
      if (val == 2) {
        if (this._strToNumber(this.weight) < 0.1) {
          this.displayError(
            "O peso do paciente não pode ser inferior à 0,1 quilogramas."
          );
        } else if (this._strToNumber(this.volume) < 0.5) {
          this.displayError(
            "O volume de soro não pode ser inferior à 0,5 mililitros."
          );
        }
      } else if (val == 3) {
        this.calculate();
      } else {
        this.chartData = null;
      }
    },
    drugsDialogModel() {
      this.$vuetify.goTo(0, {
        duration: 0,
        offset: 0,
        easing: "easeInOutCubic",
      });
    },
  },
  computed: {
    ...mapGetters("calculators", [
      "calculator",
      "getDrugs",
      "getVolume",
      "getFluidRate",
      "getWeight",
      "getFluidRateUnit",
      "drugsConcentrations",
    ]),
    ...mapGetters("general", ["getStepper"]),
    ...mapGetters("drugs", ["category"]),
    noResults() {
      return (
        !!this.results &&
        !!this.weight &&
        !!this.volume &&
        !!this.fluidRateUnit &&
        !!this.fluidRate &&
        !!this.drugs.length
      );
    },
    drugs() {
      return this.getDrugs;
    },
    weight: {
      get() {
        return this.getWeight;
      },
      set(val) {
        this.setWeight(val);
      },
    },
    volume: {
      get() {
        return this.getVolume;
      },
      set(val) {
        this.setVolume(val);
      },
    },
    fluidRateUnit: {
      get() {
        return this.getFluidRateUnit;
      },
      set(val) {
        this.setFluidRateUnit(val);
      },
    },
    fluidRate: {
      get() {
        return this.getFluidRate;
      },
      set(val) {
        this.setFluidRate(val);
      },
    },
    stepModel: {
      get() {
        return this.getStepper;
      },
      set(val) {
        this.setStepper(val);
      },
    },
    disabledStep() {
      return (
        (this.drugs.length == 0 && this.stepModel == 2) ||
        (this.stepModel == 1 &&
          (!this.weight ||
            !this.volume ||
            !this.fluidRateUnit ||
            !this.fluidRate))
      );
    },
  },
  methods: {
    ...mapMutations("general", [
      "setConfirmModel",
      "setStepper",
      "setStepperTotal",
      "setStepperData",
    ]),
    ...mapMutations("calculators", [
      "setFluidRate",
      "setFluidRateUnit",
      "setVolume",
      "setWeight",
      "setDrugs",
    ]),
    ...mapActions("general", ["routeRedirect", "showError", "logEvent"]),
    ...mapActions("calculators", [
      "openCalculatorById",
      "addDrugToContinuousInfusion",
    ]),
    selectDrug() {
      if (typeof this.name == "object") {
        this.concentrationUnit = this.name.concentrationUnit;
        this.concentration = `${this.name.concentration}`.replace(".", ",");
        this.name = this.name["name"].split("(")[0];
      }
    },
    closeDialog() {
      setTimeout(
        function () {
          this.drugsDialogModel = false;
        }.bind(this),
        100
      );
    },
    calculateSerumDuration(volume, bombSpeed) {
      let d = (volume * 3600) / bombSpeed;
      d = Number(d);
      return this._getHourMinutesSeconds(d);
    },
    parseNumberField(e) {
      const id = e.srcElement.id.replace("numeric", "");
      const { value } = this._formatNumberField(e, this[id]);
      this[id] = value;
    },
    openDrugDialog() {
      this.name = null;
      this.concentrationUnit = null;
      this.concentration = null;
      this.administrationRateUnit = null;
      this.administrationRate = null;
      this.drugsDialogModel = true;
      this.selectedDrugId = false;
    },
    saveNewDrug() {
      if (
        !this.name ||
        !this.concentrationUnit ||
        !this.concentration ||
        !this.administrationRateUnit ||
        !this.administrationRate
      ) {
        return;
      }
      const name = typeof this.name == "object" ? this.name.name : this.name;
      const hasDuplicity = this.drugs.find((d) => {
        return d.name == name;
      });
      if (hasDuplicity && !this.selectedDrugId) {
        this.showError(
          "Não é possível adicionar medicamentos com o mesmo nome à infusão."
        );
        return;
      }

      this.addDrugToContinuousInfusion({
        drug: {
          id: this._getTimestamp(),
          name,
          concentrationUnit: this.concentrationUnit,
          concentration: `${this.concentration}`,
          administrationRateUnit: this.administrationRateUnit,
          administrationRate: this.administrationRate,
        },
        previousId: this.selectedDrugId,
      }).then(
        function () {
          this.drugsDialogModel = false;
        }.bind(this)
      );
    },
    editDrug(drug) {
      this.selectedDrugId = drug.id;
      this.name = drug.name;
      this.concentrationUnit = drug.concentrationUnit;
      this.concentration = drug.concentration;
      this.administrationRateUnit = drug.administrationRateUnit;
      this.administrationRate = drug.administrationRate;
      this.drugsDialogModel = true;
    },
    deleteDrug(id) {
      this.setConfirmModel({
        active: true,
        text: calculatorLabels.DRUG_EXCLUSION,
        action: "calculators/deleteDrugFromContinuousInfusion",
        confirmText: calculatorLabels.CONFIRM_DRUG_EXCLUSION,
        closeText: labels.CANCEL,
        parameters: id,
      });
    },
    calculate() {
      if (
        !this.weight ||
        !this.volume ||
        !this.fluidRateUnit ||
        !this.fluidRate ||
        !this.drugs.length
      ) {
        return;
      }
      this.results = {};
      let convertedFluidRate = this._strToNumber(this.fluidRate);
      const constVolume = this._strToNumber(this.volume);
      if (this.fluidRateUnit == "mL/kg/dia") {
        convertedFluidRate = convertedFluidRate / 24;
      }
      this.results["bombSpeed"] =
        convertedFluidRate * this._strToNumber(this.weight);

      this.results["macroDrops"] = [];
      this.results["macroDrops"].push(
        `${this._formatNumber(
          this._roundNumber(this.results["bombSpeed"] / 180, 2)
        )} ${this._getCalculatorsLabel("UNIT_DROPS_SECONDS")}`
      );
      this.results["macroDrops"].push(
        `${this._formatNumber(
          this._roundNumber(this.results["bombSpeed"] / 18, 2)
        )} ${this._getCalculatorsLabel("UNIT_DROPS_TEN_SECONDS")}`
      );
      this.results["macroDrops"].push(
        `${this._formatNumber(
          this._roundNumber(this.results["bombSpeed"] / 3, 2)
        )} ${this._getCalculatorsLabel("UNIT_DROPS_MINUTES")}`
      );
      this.results["macroDrops"].push(
        `${this._formatNumber(
          this._roundNumber(180 / this.results["bombSpeed"], 2)
        )} ${this._getCalculatorsLabel("UNIT_SECONDS_DROPS")}`
      );

      this.results["microDrops"] = [];
      this.results["microDrops"].push(
        `${this._formatNumber(
          this._roundNumber(this.results["bombSpeed"] / 60, 2)
        )} ${this._getCalculatorsLabel("UNIT_DROPS_SECONDS")}`
      );
      this.results["microDrops"].push(
        `${this._formatNumber(
          this._roundNumber(this.results["bombSpeed"] / 6, 2)
        )} ${this._getCalculatorsLabel("UNIT_DROPS_TEN_SECONDS")}`
      );
      this.results["microDrops"].push(
        `${this._formatNumber(
          this._roundNumber(this.results["bombSpeed"], 2)
        )} ${this._getCalculatorsLabel("UNIT_DROPS_MINUTES")}`
      );
      this.results["microDrops"].push(
        `${this._formatNumber(
          this._roundNumber(60 / this.results["bombSpeed"], 2)
        )} ${this._getCalculatorsLabel("UNIT_SECONDS_DROPS")}`
      );
      this.results["serumDuration"] = this.calculateSerumDuration(
        constVolume,
        this.results["bombSpeed"]
      );

      this.results["bombSpeed"] = `${this._formatNumber(
        this._roundNumber(this.results["bombSpeed"], 2)
      )} mL/hora`;

      this.results["drugs"] = [];
      this.results["labels"] = [];
      this.results["data"] = [];
      let serumVolume = constVolume + 0;
      this.drugs.forEach((d) => {
        let obj = {};
        const rateConversion = {
          "mcg/kg/min": 16.66666667,
          "mcg/kg/hora": 1000,
          "mcg/kg/dia": 24000,
          "mg/kg/min": 1 / 60,
          "mg/kg/hora": 1,
          "mg/kg/dia": 24,
        };
        obj["name"] = d.name;
        obj["volume"] =
          this._strToNumber(d.administrationRate) /
          rateConversion[d.administrationRateUnit];
        obj["volume"] = constVolume * obj["volume"];
        obj["volume"] = obj["volume"] / convertedFluidRate;
        const concentrationConversion = {
          "%": 10,
          "mg/mL": 1,
          "mcg/mL": 0.001,
        };
        obj["volume"] = this._roundNumber(
          obj["volume"] /
            (this._strToNumber(d.concentration) *
              concentrationConversion[d.concentrationUnit]),
          3
        );
        if (Number.isNaN(obj["volume"])) {
          return this.displayError(
            "Para os valores informados não é possível realizar a diluição. Confira os valores e tente novamente."
          );
        } else if (obj["volume"] > constVolume) {
          obj["finalVolumeResult"] =
            "Parametros inválidos. O volume de medicamento calculado é superior ao volume total informado na primeira etapa.";
        } else {
          obj["finalVolumeResult"] = `Adicione ${this._formatNumber(
            obj["volume"]
          )} mL do medicamento  em ${this._formatNumber(
            constVolume - obj["volume"]
          )} mL de soro.`;
        }
        const drugConcentrationCalc =
          (obj["volume"] *
            (this._strToNumber(d.concentration) *
              concentrationConversion[d.concentrationUnit])) /
          constVolume;
        obj["concentrations"] = [
          `${this._formatNumber(drugConcentrationCalc)} mg/mL`,
          `${this._formatNumber(drugConcentrationCalc * 1000)} mcg/mL`,
        ];
        serumVolume -= obj["volume"];
        this.results["drugs"].push(obj);
        this.results["labels"].push(
          `${this._formatNumber(obj["volume"])} mL de ${d.name}`
        );
        this.results["data"].push(obj["volume"]);
      });
      this.results["labels"].unshift(
        `${this._formatNumber(serumVolume)} mL de Soro`
      );
      if (serumVolume < 0) {
        return this.displayError(
          "Para os valores informados não é possível realizar a diluição. Confira os valores e tente novamente."
        );
      }
      this.results["data"].unshift(serumVolume);
      const fixedColors = [
        "rgb(0, 114, 138, 0.14)",
        "#00728a",
        "#193153",
        "#116384",
        "#225b73",
        "#2e5767",
        "#39525c",
        "#454d50",
      ];
      this.results["colors"] = [];
      this.results["labels"].forEach((_, index) => {
        this.results["colors"].push(fixedColors[index]);
      });
      this.chartData = {
        labels: this.results["labels"],
        datasets: [
          {
            backgroundColor: this.results["colors"],
            data: this.results["data"],
          },
        ],
      };
    },
    displayError(message) {
      this.showError(message);
      this.stepModel = 1;
    },
    setupVariables() {
      [
        "weight",
        "volume",
        "fluidrate",
        "newdrugconcentration",
        "newdrugadministrationrate",
      ].forEach((n) => {
        let el = document.getElementById(`numeric-${n}`);
        el.value = 0;
        el.addEventListener("input", this.parseNumberField);
        el.addEventListener("focus", this.parseNumberField);
        el.addEventListener("blur", this.parseNumberField);
      });
    },
  },
  data() {
    return {
      noDrugsImage: imagesConstants.SEARCH,
      labels,
      calculatorLabels,
      mdiCheck,
      mdiPlus,
      mdiClose,
      mdiAlertCircleOutline,
      headerHeight: 0,
      fluidRateUnits: ["mL/kg/hora", "mL/kg/dia"],

      name: null,
      concentrationUnits: ["%", "mg/mL", "mcg/mL"],
      concentrationUnit: null,
      concentration: null,
      administrationRateUnits: [
        "mcg/kg/min",
        "mcg/kg/hora",
        "mcg/kg/dia",
        "mg/kg/min",
        "mg/kg/hora",
        "mg/kg/dia",
      ],
      administrationRateUnit: null,
      administrationRate: null,
      selectedDrugId: false,
      drugsDialogModel: false,
      results: null,
      chartData: null,
    };
  },
  mounted() {
    if (this.calculator) {
      this.setupVariables();
      this._setupScreenSizes(this);
    }
  },
  created: async function () {
    if (
      !this.calculator ||
      this.calculator.id !== calculatorLabels.CONTINUOUS_INFUSION_ID
    ) {
      await this.openCalculatorById({
        id: calculatorLabels.CONTINUOUS_INFUSION_ID,
        redirect: false,
      });
      this.setupVariables();
      this._setupScreenSizes(this);
    }
    this.setStepper(1);
    this.setStepperTotal(3);
    this.setStepperData(stepperData);
    this.setWeight(null);
    this.setVolume(null);
    this.setFluidRate(null);
    this.setFluidRateUnit(null);
    this.setDrugs([]);
  },
};
</script>
